import React, { useEffect, useState } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Button,
  FormControl,
  FormLabel,
  Input,
  useToast,
  Select,
  HStack,
  Box,
  Text,
  Card,
  CardBody,
  CardFooter,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Flex,
  TableContainer,
  Table,
  Thead,
  Th,
  Tr,
  Tbody,
  Td,
  Tooltip,
  IconButton,
  AlertDialog,
  AlertDialogOverlay,
  AlertDialogContent,
  AlertDialogCloseButton,
  AlertDialogFooter,
  AlertDialogBody,
  AlertDialogHeader,
  useDisclosure,
  Spacer,
} from '@chakra-ui/react';
import { AppDispatch, Store } from '../Store/StoreInit';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import { useMsal } from '@azure/msal-react';
import {
  IDocuments,
  IOverrideItem,
  IPayerFormVariationItem,
  IScenarioItem,
  IVariations,
} from '../Infrastructure/Interfaces';
import { ChevronRightIcon } from '@chakra-ui/icons';
import { ImBin } from 'react-icons/im';
import { fetchOverridesList } from '../Store/ScenariosReducer';
import { fetchSceneriosList } from '../Store/GetDropDownsValuesReducer';

interface Props {
  isOpen?: any;
  onOpen?: any;
  onClose?: any;
}

const PayerFormModalPoupup: React.FC<Props> = (props: Props) => {
  var documentList: IDocuments[] = useSelector((state: any) => {
    return state.getFormDropdownList.documentsList;
  });
  var variationList: IVariations[] = useSelector((state: any) => {
    return state.getFormDropdownList.variationsList;
  });
  const [filteredVariationList, setFilteredVariationList] =
    useState<IVariations[]>();
  const [filteredOverrideVariationList, setFilteredOverrideVariationList] =
    useState<IVariations[]>();
  const dispatch = useDispatch<AppDispatch>();
  const toast = useToast();
  var overrideslist: IOverrideItem = useSelector((state: any) => {
    return state.overridesList.overrideList;
  });
  const {
    isOpen: isDeleteAlertOpen,
    onOpen: onDeleteAlertOpen,
    onClose: onDeleteAlertClose,
  } = useDisclosure();
  const [toBeDeletedItem, setToBeDeleteItem] =
    useState<IOverrideItem>();
  const [payerFormDelete, setPayerFormDelete] = useState<IScenarioItem>();
  const { accounts } = useMsal();
  const userdetails = JSON.parse(localStorage.getItem('userdetails') || '');
  const userid =
    userdetails[0].portal_Id != ''
      ? userdetails[0].portal_Id
      : accounts[0].username;
  const cancelRef = React.useRef(null);
  const [deleteOkLoading, setDeleteOkLoading] = useState(false);
  const userrole =
    userdetails[0].userRole != '' ? userdetails[0].userRole : 'User';
  const userAuthorized = process.env.REACT_APP_USER_ROLES as string;
  const splitauthorized = userAuthorized.split(',');
  const userAuthorizedFlag = splitauthorized.some(function (v) {
    return v === userrole;
  });
  const [saveScenariosButtonLoading, setSaveScenariosButtonLoading] =
    useState(false);
  const [savePayerFormButtonLoading, setSavePayerFormButtonLoading] =
    useState(false);
    
  const [alertDialogFields, setALertDialogFields] = useState({
    title: '',
    message: '',
    deleteItem: '',
  });
  const [shouldSubmit, setShouldSubmit] = useState(false);

  const [data, setData] = useState({
    variatioName: '',
    variationDesc: '',
    documentName: '',
    documentDesc: '',
  });

  const [payerFormData, setPayerFormData] = useState({
    payerFormOverride:'',
    overrideDocumentId: 0,
    overrideVariationId: 0,
  });

  const [scenarioData, setScenarioData] = useState({
    scenarioid: 0,
    documentid: 0,
    variationid: 0,
    name: '',
    billing_admin: '',
    billing_system: '',
    billing_client: '',
    chart_required: false,
    eob_required: false,
    claim_required: false,
    deliver_option: '',
    deliver_regard: '',
    deliver_to_email_address: '',
    fax_to: '',
    fax_to_faxnumber: '',
    fax_user: '',
    fax_secret: '',
    requestor_first_name: '',
    requestor_last_name: '',
    requestor_phone: '',
    requestor_fax: '',
    requestor_email_address: '',
    requestor_signature: '',
    requestor_company_name: '',
    requestor_company_address1: '',
    requestor_company_address2: '',
    requestor_company_city: '',
    requestor_company_state: '',
    requestor_company_zip: '',
    requestor_alternate_contact: '',
    page_limit: '',
    next_delivery: '',
    upload_channel: '',
    default_channel: false,
  });

  function deleteItemDialog(item: IOverrideItem) {
    setALertDialogFields({
      ...alertDialogFields,
      title: 'Remove Payer Form Override?',
      message: 'Are you sure you want to remove this payer form override?',
      deleteItem: 'removeoverride',
    });
    setToBeDeleteItem(item);
    onDeleteAlertOpen();
  }

  function deletePayeFormDialog() {
    setALertDialogFields({
      ...alertDialogFields,
      title: 'Remove Payer Form?',
      message: 'Are you sure you want to remove this payer form?',
      deleteItem: 'removepayerform',
    });
    setPayerFormDelete(scenarioData);
    onDeleteAlertOpen();
  }

  async function deleteOverrideItem(item: any) {
    setDeleteOkLoading(true);
    const tokenurl = process.env.REACT_APP_SCENARIO_TOKEN_URL as string;
    const baseurl = process.env.REACT_APP_SERVER_SCENARIOS_BASE_URL as string;
    const url: string = `${baseurl}/Appeal/delete_scenario_form_override?id=${item?.id}&user=${accounts[0].username}`;

    try {
      const res = await axios.get(tokenurl);
      if (res.data.success) {
        const response = await axios.post(url, null, {
          headers: {
            Pragma: 'no-cache',
            Authorization: `Bearer ${res.data.token}`,
          },
        });

        if (response.data.success) {
          showToast('Success', `deleted successfully`, 'success');
          onDeleteAlertClose();
          dispatch(fetchOverridesList(item.scenarioid));
        }
      }
    } catch (error: any) {
      showToast(
        'Error!',
        error.response.data.message || error.message,
        'error'
      );
      onDeleteAlertClose();
    } finally {
      setDeleteOkLoading(false);
    }
  }

  useEffect(() => {
    Store.subscribe(() => {
      setScenarioData({
        ...scenarioData,
        scenarioid: Store.getState().setScenariosItem.value.scenarioid,
        documentid: Store.getState().setScenariosItem.value.documentid,
        variationid: Store.getState().setScenariosItem.value.variationid,
        name: Store.getState().setScenariosItem.value.name,
        billing_admin: Store.getState().setScenariosItem.value.billing_admin,
        billing_system: Store.getState().setScenariosItem.value.billing_system,
        billing_client: Store.getState().setScenariosItem.value.billing_client,
        chart_required: Store.getState().setScenariosItem.value.chart_required,
        eob_required: Store.getState().setScenariosItem.value.eob_required,
        claim_required: Store.getState().setScenariosItem.value.claim_required,
        deliver_option: Store.getState().setScenariosItem.value.deliver_option,
        deliver_regard: Store.getState().setScenariosItem.value.deliver_regard,
        deliver_to_email_address:
          Store.getState().setScenariosItem.value.deliver_to_email_address,
        fax_to: Store.getState().setScenariosItem.value.fax_to,
        fax_to_faxnumber:
          Store.getState().setScenariosItem.value.fax_to_faxnumber,
        fax_user: Store.getState().setScenariosItem.value.fax_user,
        fax_secret: Store.getState().setScenariosItem.value.fax_secret,
        requestor_first_name:
          Store.getState().setScenariosItem.value.requestor_first_name,
        requestor_last_name:
          Store.getState().setScenariosItem.value.requestor_last_name,
        requestor_phone:
          Store.getState().setScenariosItem.value.requestor_phone,
        requestor_fax: Store.getState().setScenariosItem.value.requestor_fax,
        requestor_email_address:
          Store.getState().setScenariosItem.value.requestor_email_address,
        requestor_signature:
          Store.getState().setScenariosItem.value.requestor_signature,
        requestor_company_name:
          Store.getState().setScenariosItem.value.requestor_company_name,
        requestor_company_address1:
          Store.getState().setScenariosItem.value.requestor_company_address1,
        requestor_company_address2:
          Store.getState().setScenariosItem.value.requestor_company_address2,
        requestor_company_city:
          Store.getState().setScenariosItem.value.requestor_company_city,
        requestor_company_state:
          Store.getState().setScenariosItem.value.requestor_company_state,
        requestor_company_zip:
          Store.getState().setScenariosItem.value.requestor_company_zip,
        requestor_alternate_contact:
          Store.getState().setScenariosItem.value.requestor_alternate_contact,
        page_limit: Store.getState().setScenariosItem.value.page_limit,
        next_delivery: Store.getState().setScenariosItem.value.next_delivery,
        upload_channel: Store.getState().setScenariosItem.value.upload_channel,
        default_channel:
          Store.getState().setScenariosItem.value.default_channel,
      });
    });
  }, []);

  useEffect(() => {
    fetchDocumentAndVariation();
  }, [props.isOpen]);

  function deletePayeFormConfirmed() {
    setScenarioData(prev => ({ ...prev, documentid: 0, variationid: 0 }));
    setShouldSubmit(true);
  }

  function fetchDocumentAndVariation() {
    let documentname = 'None';
    let documentdescription = 'None';
    let variationname = 'None';
    let variationdescription = 'None';
    let curdoc = null;

    if (scenarioData.variationid > 0) {
      curdoc = variationList.filter(
        x => x.variationid == scenarioData.variationid
      );
      variationname = curdoc != null && curdoc.length > 0 ? curdoc[0].name : '';
      variationdescription =
        curdoc != null && curdoc.length > 0 ? curdoc[0].description : '';
    }
    if (scenarioData.documentid > 0) {
      curdoc = documentList.filter(
        x => x.documentid == scenarioData.documentid
      );
      documentname = curdoc != null && curdoc.length > 0 ? curdoc[0].name : '';
      documentdescription =
        curdoc != null && curdoc.length > 0 ? curdoc[0].description : '';
    }

    setData({
      ...data,
      documentName: documentname,
      documentDesc: documentdescription,
      variatioName: variationname,
      variationDesc: variationdescription,
    });
  }

  useEffect(() => {
    if (shouldSubmit) {
      handleSubmit();
      onDeleteAlertClose();
      setShouldSubmit(false); // Reset for next usage
    }
  }, [scenarioData, shouldSubmit]);

  const handleChange = (e: any) => {
    e.preventDefault();
    const { id, value } = e.target;
    if (id == 'overrideVariationId' || id == 'payerFormOverride') {
      setPayerFormData({
        ...payerFormData,
        [id]: value,
      });
    } else {
      setScenarioData(prev => ({ ...prev, [id]: value }));
    }
  };

  async function handleSubmit() {
    //e.preventDefault();

    //setSaveScenariosButtonLoading(true);

    const tokenurl = process.env.REACT_APP_SCENARIO_TOKEN_URL as string;
    const baseurl = process.env.REACT_APP_SERVER_SCENARIOS_BASE_URL as string;
    try {
      const res = await axios.get(tokenurl);
      if (res.data.success) {
        const url = `${baseurl}/Appeal/update_scenario`;
        const response = await axios.post(url, JSON.stringify(scenarioData), {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${res.data.token}`,
          },
        });
        //setSaveScenariosButtonLoading(false);

        if (response.data.success) {
          showToast('Success', response.data.message, 'success');
          fetchDocumentAndVariation();
        }
      }
    } catch (error: any) {
      //setSaveScenariosButtonLoading(false);
      showToast(
        'Error!',
        error.response.data.message || error.message,
        'error'
      );
    }
  }

  const handleDocumentDDChange = (e: any) => {
    const { id, value } = e.target;
    setFilteredVariationList(
      variationList.filter(x => x.documentid == e.target.value)
    );
    setScenarioData(prev => ({ ...prev, [id]: value }));
  };

  const handleOverrideDocumentDDChange = (e: any) => {
    const { id, value } = e.target;
    setFilteredOverrideVariationList(
      variationList.filter(x => x.documentid == e.target.value)
    );
    setPayerFormData(prev => ({ ...prev, [id]: e.target.value }));
    //setScenarioData(prev => ({...prev, [id]: value}))
  };

  function showToast(
    title: string,
    description: string,
    status: 'error' | 'success'
  ) {
    toast({
      title,
      description,
      position: 'top',
      status,
      duration: status === 'error' ? 10000 : 5000,
      isClosable: true,
    });
  }

  function getLatestScenariosList() {
    dispatch(fetchSceneriosList());
  }

  async function handlePayerFormOverrideSubmit() {

    const overridedata = JSON.stringify({
      scenarioid: scenarioData.scenarioid,
      identifier:payerFormData.payerFormOverride,
      documentid: payerFormData.overrideDocumentId,
      variationid:payerFormData.overrideVariationId   
  });

    setSavePayerFormButtonLoading(true);

    const tokenurl = process.env.REACT_APP_SCENARIO_TOKEN_URL as string;
    const baseurl = process.env.REACT_APP_SERVER_SCENARIOS_BASE_URL as string;
    try {
      const res = await axios.get(tokenurl);
      if (res.data.success) {
        const url = `${baseurl}/Appeal/add_scenario_form_override`;
        const response = await axios.post(url, overridedata, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${res.data.token}`,
          },
        });
        //props.onOpen();
        setSavePayerFormButtonLoading(false);

        if (response.data.success) {
          showToast('Success', response.data.message, 'success');
          dispatch(fetchOverridesList(scenarioData.scenarioid));
        }
      }
    } catch (error: any) {
      setSavePayerFormButtonLoading(false);
      showToast(
        'Error!',
        error.response.data.message || error.message,
        'error'
      );
    }
  }

  return (
    <>
      <Modal
        closeOnOverlayClick={false}
        size={'full'}
        isOpen={props.isOpen}
        onClose={props.onClose}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            <Breadcrumb
              spacing="8px"
              separator={<ChevronRightIcon color="gray.500" />}
            >
              <BreadcrumbItem>
                <BreadcrumbLink onClick={() => getLatestScenariosList()}>
                  Scenarios
                </BreadcrumbLink>
              </BreadcrumbItem>

              <BreadcrumbItem isCurrentPage>
                <BreadcrumbLink href="#">{scenarioData.name}</BreadcrumbLink>
              </BreadcrumbItem>
            </Breadcrumb>
          </ModalHeader>
          <ModalCloseButton
            onClick={() => getLatestScenariosList()}
            color="black"
          />{' '}
          <ModalBody>
            <Box display=" flex" flexDirection="column">
              <Box padding={2}>
                <Box
                  width="50%"
                  float="left"
                  border="1px"
                  borderColor="lightgrey"
                  borderRadius={10}
                >
                  <Card maxWidth="60%" margin={2}>
                    <CardBody>
                      <FormControl>
                        <FormLabel>Payer Form:</FormLabel>
                        <Text>{data.documentName}</Text>
                      </FormControl>
                      <FormControl>
                        <FormLabel>Description:</FormLabel>
                        <Text>{data.documentDesc}</Text>
                      </FormControl>
                      <FormControl>
                        <FormLabel>Variation:</FormLabel>
                        <Text>{data.variatioName}</Text>
                      </FormControl>
                      <FormControl>
                        <FormLabel>Variation Description:</FormLabel>
                        <Text>{data.variationDesc}</Text>
                      </FormControl>
                      <CardFooter
                        alignContent="right"
                        alignItems="right"
                        style={{ float: 'right' }}
                      >
                        <Button
                          variant="solid"
                          bg="#002677"
                          color="white"
                          float="right"
                          onClick={() => deletePayeFormDialog()}
                        >
                          Remove Payer Name
                        </Button>
                      </CardFooter>
                    </CardBody>
                  </Card>
                </Box>
                <Box
                  width="50%"
                  float="right"
                  border="1px"
                  borderColor="lightgrey"
                  borderRadius={10}
                >
                  <Card minWidth="100%">
                    <CardBody>
                      <FormControl>
                        <FormLabel>Payer Form Overrides:</FormLabel>
                        {Array.isArray(overrideslist) && overrideslist.length > 0 ? (
                          <Flex>
                            <TableContainer width='100%'>
                              <Table
                                whiteSpace="break-spaces"
                                variant="striped"
                                colorScheme="blackAlpha"
                                size="xs"
                                overflow="Auto"
                              >
                                <Thead bgColor="#002677">
                                  <Tr>
                                    <Th fontSize="xs" color="white" pl={2}>
                                      IDENTIFIER
                                    </Th>
                                    <Th fontSize="xs" color="white">
                                      DOCUMENT
                                    </Th>
                                    <Th fontSize="xs" color="white">
                                      VARIATION
                                    </Th>
                                    {userAuthorizedFlag && (
                                      <Th fontSize="xs" color="white" isNumeric>
                                        ACTIONS
                                      </Th>
                                    )}
                                  </Tr>
                                </Thead>
                                <Tbody>
                                  {overrideslist.map(overideitem => {
                                      return (
                                        <>
                                          <Tr key={overideitem.id}>
                                            <Td>{overideitem.identifier}</Td>
                                            <Td>{documentList.filter(x=> x.documentid == overideitem.documentid)[0]?.name}</Td>
                                            <Td>{variationList.filter(x=> x.variationid == overideitem.variationid)[0]?.name}</Td>
                                            {userrole.toUpperCase() !=
                                            'USER' ? (
                                              <Td
                                                pt="0"
                                                pb="0"
                                                mt="0"
                                                mb="0"
                                                isNumeric
                                                pr="25px"
                                              >
                                                <Tooltip
                                                  hasArrow
                                                  label="Delete item"
                                                  bg="grey.300"
                                                  color="black"
                                                >
                                                  <IconButton
                                                    size="xs"
                                                    ml={4}
                                                    bg="none"
                                                    aria-label="Delete"
                                                    icon={<ImBin />}
                                                    onClick={() =>
                                                      deleteItemDialog(
                                                        overideitem
                                                      )
                                                    }
                                                  />
                                                </Tooltip>
                                              </Td>
                                            ) : (
                                              ''
                                            )}
                                          </Tr>
                                        </>
                                      );
                                    }
                                  )}
                                </Tbody>
                              </Table>
                            </TableContainer>
                          </Flex>
                        ) : (
                          <Text>No Overrides</Text>
                        )}
                      </FormControl>
                    </CardBody>
                  </Card>
                </Box>
              </Box>
              <Box padding={2}>
                <Box
                  width="50%"
                  float="left"
                  border="1px"
                  borderColor="lightgrey"
                  borderRadius={10}
                >
                  <Card maxWidth="60%" margin={2}>
                    <CardBody>
                      <HStack>
                        <FormControl>
                          <FormLabel>Document:</FormLabel>
                          <Select
                            width={60}
                            placeholder="--none--"
                            name="documentid"
                            id="documentid"
                            onChange={e => handleDocumentDDChange(e)}
                          >
                            {documentList.map(document => (
                              <option
                                key={document.documentid}
                                value={document.documentid}
                              >
                                {document.name}
                              </option>
                            ))}
                          </Select>
                        </FormControl>
                        <FormControl>
                          <FormLabel>Variation:</FormLabel>
                          <Select
                            width={60}
                            placeholder="--none--"
                            name="variationid"
                            id="variationid"
                            onChange={e => handleChange(e)}
                          >
                            {filteredVariationList &&
                              filteredVariationList.map(variation => (
                                <option
                                  key={variation.variationid}
                                  value={variation.variationid}
                                >
                                  {variation.name}
                                </option>
                              ))}
                          </Select>
                        </FormControl>
                      </HStack>
                    </CardBody>
                  </Card>
                </Box>
                <Box
                  width="50%"
                  float="right"
                  border="1px"
                  borderColor="lightgrey"
                  borderRadius={10}
                >
                  <Card maxWidth="60%" margin={2}>
                    <CardBody>
                      <FormLabel fontWeight="bold">
                        Payer Form Override:
                      </FormLabel>
                      <Input
                        size="sm"
                        type="text"
                        name="payerFormOverride"
                        id="payerFormOverride"
                        onChange={(e) => handleChange(e)}
                      />
                      <HStack>
                        <FormControl>
                          <FormLabel>Document:</FormLabel>
                          <Select
                            placeholder="--none--"
                            name="overrideDocumentId"
                            id="overrideDocumentId"
                            onChange={e => handleOverrideDocumentDDChange(e)}
                          >
                            {documentList.map(document => (
                              <option
                                key={document.documentid}
                                value={document.documentid}
                              >
                                {document.name}
                              </option>
                            ))}
                          </Select>
                        </FormControl>
                        <FormControl>
                          <FormLabel>Variation:</FormLabel>
                          <Select
                            placeholder="--none--"
                            name="overrideVariationId"
                            id="overrideVariationId"
                            onChange={e => handleChange(e)}
                          >
                            {filteredOverrideVariationList &&
                              filteredOverrideVariationList.map(variation => (
                                <option
                                  key={variation.variationid}
                                  value={variation.variationid}
                                >
                                  {variation.name}
                                </option>
                              ))}
                          </Select>
                        </FormControl>
                      </HStack>
                    </CardBody>
                  </Card>
                </Box>
              </Box>
              <Box padding={2}>
                <Box width="50%" float="left">
                  <Button
                    variant="solid"
                    bg="#002677"
                    color="white"
                    float="right"
                    onClick={() => handleSubmit()}
                    isLoading={saveScenariosButtonLoading}
                  >
                    Save
                  </Button>
                </Box>
                <Box width="50%" float="right">
                  <Button
                    ml={2}
                    variant="solid"
                    bg="#002677"
                    color="white"
                    float="right"
                    onClick={() => handlePayerFormOverrideSubmit()}
                  >
                    Save
                  </Button>
                  <Button
                    variant="solid"
                    bg="#002677"
                    color="white"
                    float="right"
                    onClick={() => getLatestScenariosList()}
                  >
                    Cancel
                  </Button>
                </Box>
              </Box>
            </Box>
          </ModalBody>
        </ModalContent>
      </Modal>
      <AlertDialog
        motionPreset="scale"
        isOpen={isDeleteAlertOpen}
        leastDestructiveRef={cancelRef}
        onClose={onDeleteAlertClose}
        isCentered
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              {alertDialogFields.title}
            </AlertDialogHeader>
            <AlertDialogCloseButton color="black" />
            <AlertDialogBody>
              {/* Are you sure you want to remove this payer form override <b>{toBeDeletedItem && (toBeDeletedItem as any)?.identifier}</b> ? */}
              {alertDialogFields.message}
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button
                bg="#002677"
                color="white"
                onClick={onDeleteAlertClose}
                ml={3}
              >
                Cancel
              </Button>
              <Spacer />
              <Button
                isLoading={deleteOkLoading}
                bg="#002677"
                color="white"
                ref={cancelRef}
                onClick={
                  alertDialogFields.deleteItem === 'removepayerform'
                    ? () => deletePayeFormConfirmed()
                    : () => deleteOverrideItem(toBeDeletedItem!)
                }
              >
                Ok
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  );
};

export default PayerFormModalPoupup;
